import { render, staticRenderFns } from "./GeneralRequirements.vue?vue&type=template&id=14d9e966&scoped=true&"
import script from "./GeneralRequirements.vue?vue&type=script&lang=js&"
export * from "./GeneralRequirements.vue?vue&type=script&lang=js&"
import style0 from "./GeneralRequirements.vue?vue&type=style&index=0&id=14d9e966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d9e966",
  null
  
)

export default component.exports